import React, { FC } from 'react'

// TODO - Add error id
const ErrorPage: FC = () => {
  return <p>Client Error page</p>
}

export default ErrorPage
